import { createContext } from 'react';

export const TargetAllowedContext = createContext(new Map<string, boolean>());
export const NumLineItemsContext = createContext({
  numLineItemsMap: new Map<string, number>(),
});
